import { HubConnectionBuilder } from '@microsoft/signalr'
import Vue from 'vue'

const connection = new HubConnectionBuilder()
  .withUrl('/logisticHub')
  .withAutomaticReconnect()
  .build()

Vue.prototype.$signals = connection

connection.start()

export default connection
